import { render, staticRenderFns } from "./StatisticFormations.vue?vue&type=template&id=9b8de242"
import script from "./StatisticFormations.vue?vue&type=script&lang=js"
export * from "./StatisticFormations.vue?vue&type=script&lang=js"
import style0 from "./StatisticFormations.vue?vue&type=style&index=0&id=9b8de242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports